import React from 'react';
import OpponentTeamSheetPanel from '../../../components/OpponentTeamSheetPanel';

export default function HelpOpponentContactPanel({ teamContext, match }) {
  const teamId = teamContext?.teamId;
  const matchId = match?.id;

  if (!teamId || !matchId) {
    return null;
  }

  return (
    <OpponentTeamSheetPanel
      matchId={String(matchId)}
      teamId={String(teamId)}
      active
      contactFocus
    />
  );
}
